const parsePageNr = (page) => {
  const pageNr = page * 1;
  const pagination = pageNr === 1 ? 0 : pageNr - 1;
  return pagination || 0;
};

export default parsePageNr;
